import { ArrowRight } from "lucide-react";
import { useSEO } from "../lib/seo";
import { useCmsSeo } from "../lib/cmsSeo";

export default function AboutPage({ onBook }) {
  const seo = useCmsSeo("about", {
    title: "About GenieX — Intelligent Living, made in India",
    description:
      "GenieX is an Indian ultra-premium smart home brand engineering Dynamic Series interactive switches, KNX and WiFi automation for discerning homes across India.",
    path: "/about",
    keywords: "about GenieX, smart home brand India, Hyderabad smart home, luxury home automation",
  });
  useSEO(seo);

  return (
    <main data-testid="about-page" className="bg-[var(--gx-bg)] text-white">
      <section className="relative pt-32 lg:pt-40 pb-16 lg:pb-20 grain">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(201,169,97,0.12),transparent_60%)]" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
          <p className="eyebrow mb-4">About</p>
          <h1 className="h1-display max-w-[18ch]">
            A quiet brand for<br />
            <span className="text-gold">discerning homes.</span>
          </h1>
        </div>
      </section>

      <section className="border-t border-line">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-[1fr_1.2fr] gap-12">
          <div>
            <p className="eyebrow text-gold mb-3">Our Story</p>
            <h2 className="h2-display max-w-[18ch]">Built for India. Engineered for life.</h2>
          </div>
          <div className="space-y-5 text-dim text-[15px] leading-relaxed">
            <p>
              GenieX began with a simple observation: the best Indian homes deserve a smart home
              system designed for the way Indian families actually live — across cuisines,
              celebrations, climates and cities.
            </p>
            <p>
              We design, curate and integrate the world's finest automation components into a
              single, coherent experience. From an apartment in Gachibowli to a villa in Jubilee
              Hills, our promise is the same — quiet intelligence, beautifully delivered.
            </p>
            <p>
              No mascots. No gimmicks. Just a calm system that disappears into the architecture and
              shows up only when needed.
            </p>
          </div>
        </div>
      </section>

      <section className="border-t border-line bg-[var(--gx-black)]">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 grid sm:grid-cols-3 gap-8 text-center">
          {[
            { k: "500+", v: "Homes delivered" },
            { k: "15+", v: "Cities served" },
            { k: "5 yrs", v: "Replacement warranty" },
          ].map((s) => (
            <div key={s.v}>
              <p className="font-display text-5xl text-white">{s.k}</p>
              <p className="text-[11px] tracking-[0.28em] uppercase text-mute mt-2">{s.v}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-line">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 text-center">
          <h2 className="h2-display max-w-[22ch] mx-auto">Come see it for yourself.</h2>
          <button onClick={onBook} className="btn-gold mt-9 mx-auto">
            Visit our Experience Studio <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>
    </main>
  );
}
